import React from 'react';
import propTypes from 'prop-types';
import { useLabels, usePrefs } from 'wsm-common-data';
import { MOBILE } from '../utils/widgetInfoDefaults';

const Awards = ({ dealerData, deviceType }) => {
	const labels = useLabels();
	const flags = dealerData?.dealerData?.flags || [];
	const { communityAwardImageUrl, customerAwardImageUrl, goldAwardImageUrl } =
		usePrefs();

	const getAwardsInfo = (flagsList) => {
		if (flagsList.includes('lpgold')) {
			return {
				image: goldAwardImageUrl,
				header: labels.get('LOVE_PROMISE_AWARD_GOLD_HEADER'),
				content: labels.getHTML('LOVE_PROMISE_AWARD_GOLD_CONTENT')
			};
		} else if (flagsList.includes('lpcust')) {
			return {
				image: customerAwardImageUrl,
				header: labels.get('LOVE_PROMISE_AWARD_CUSTOMER_HEADER'),
				content: labels.getHTML('LOVE_PROMISE_AWARD_CUSTOMER_CONTENT')
			};
		} else if (flagsList.includes('lpcomm')) {
			return {
				image: communityAwardImageUrl,
				header: labels.get('LOVE_PROMISE_AWARD_COMMUNITY_HEADER'),
				content: labels.getHTML('LOVE_PROMISE_AWARD_COMMUNITY_CONTENT')
			};
		}
		return null;
	};

	const award = getAwardsInfo(flags);

	// If no award flag was found, don't render component
	if (award === null) return null;

	return (
		<div className="lp-awards row">
			<div className="col-sm-8 col-xs-12 mt-6">
				<h3
					className={`h3 text-center text-sm-left font-weight-normal ${
						deviceType !== MOBILE ? 'ddc-font-size-xxlarge' : ''
					}`}
				>
					{award.header}
				</h3>
				<img
					className="visible-xs mx-auto mb-4"
					src={award.image}
					alt={award.header}
				/>
				{award.content}
			</div>
			<div className="hidden-xs col-sm-4 mt-7 mb-4">
				<img className="mx-auto" src={award.image} alt={award.header} />
			</div>
		</div>
	);
};

export default Awards;

const AwardsProps = {
	deviceType: propTypes.string.isRequired,
	dealerData: propTypes.shape({
		dealerData: propTypes.shape({
			flags: propTypes.arrayOf(propTypes.string)
		})
	}).isRequired
};

Awards.propTypes = AwardsProps;
